<template>
  <div class="all-style-bgc">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoreportInternet">清风论坛></span>
        <span @click="GoreportEvaluation">他山之石></span>
        <span @click="GoreportOutside">学习他人></span>
        <span class="red">正文</span>
      </div>
      <!--正文内容-->
      <div class="text">
        <h1>金国江：关于基层信访举报工作现状、原因分析及其对策建议</h1>
        <h2>
          来源：新华社
          <span class="mg-16">|</span>
          发布时间：2020-03-30&nbsp;13:30
        </h2>

        <h3>党的十八大以来，习近平总书记对信访举报工作高度重视，作出一系列重要指示，他强调：信访工作是了解民情、集中民智、维护民利、凝聚民心的一项重要工作。总书记的指示精神为做好新形势下信访工作指明了努力方向、提供了根本遵循。近年来，枣阳市纪委监委始终坚持人民立场，不忘为民初心,把信访举报作为纪律审查的线索的第一来源渠道，充分发挥其“预警器”和“晴雨表”作用，注重精准分析，提高办信质效，积极探索化解基层信访问题的新途径、新办法，不断推进信访举报工作高质量发展。</h3>
        <h3>
          <b>一、基层信访反映现状</b>
        </h3>
        <h3>(一）从举报对象分析，“抱团”违纪不容忽视。从信访举报涉及人员分析，乡镇（街道）党员干部、村（社区）干部是群众反映的主体。尤其是村（社区）干部因离群众近，离监督远，加之个人思想认识不高，纪律意识淡薄，自我管理不严，以致违纪问题频发。2019年全市收到的995件信访举报中，反映村（社区）人员419件，占48.11%。从村（社区）干部受处理具体案例来分析，两人或两人以上“抱团”违纪现象比较普遍。主要表现为以村支部书记、主任为核心，其他村组干部参与、共同“谋划”的利益“小团体”，成为违纪违法问题的高危群体。如，该市太平镇崔垱村、大王村从村支部书记到村委会委员，集体挪用粮食直补款、坐收坐支集体资金等，涉及村“两委”干部达5人。+体会交流+廉政党课”的方式召开了“一案一教育”警示教育大会，强化警示教育的感染力和说服力。</h3>
        <h3>（二）从举报频率分析，多次受处分问题仍有发生。从十八大以来被举报查处人员来看，党员干部受两次及以上举报并被查处的共有179名，其中有157名党员共受到2次处分，18人受到3次处分，受处分次数最多的达到4次。如，该市某基层国土管理所李某，2014年-2018年在担任该所党支部书记、所长期间，违反中央八项规定精神、违反政治纪律、挪用公款、非法占有公共财物等，被群众多次举报。其中违反中央八项规定精神达3次之多，从党内警告处分直至给予留党察看。分析多次被举报受处分人员情况，国家工作人员71人，农村党员干部108人。其中村（社区）主职干部被举报频率较高，受处分达72人，占比40.22%。</h3>
        <h3>（三）从反映问题分析，变相违纪比较突出。从近年来群众举报问题分析，部分党员干部的违纪违法行为从台前转向幕后，作案手段也更加隐蔽。主要表现在一些党员干部通过虚列开支、巧立名目、化整为零、变相支出等方式，达到非法支出或解决不合理费用的目的。重点表现在违反中央八项规定精神方面。2019年，枣阳市纪委收到群众举报党员干部违反中央八项规定精神问题38件，处理党员干部60人。如关于某基层财政所一辆公车两年更换12条轮胎问题，经查发现该所将拆迁租车费变相纳入公车维修费，枣阳市纪委给予该所主任余某某党内严重警告处分、副主任张某某党内警告处分。</h3>
        <h3>
          <b>二、主要特点及原因分析</b>
        </h3>
        <h3>（一）信访反映数据存在“三增三降”。主要表现在：一是“重复访”增加，“越级访”下降。2019年重复反映信访326件，占信访举报总量的32.76%，同比增长7.25%。主要原因是由于各地各单位受理信访举报的时间不同，信访人担心信访件未被受理或重视不够，在等待的过程中重复反映问题，导致重复访数量居高不下。2019年越级访15件次，同比下降57.14%。主要原因是枣阳市纪委监委领导班子认真执行定期下访接访制度，主要领导每周四固定接访，去年共接待群众面访36批次581人次，上访对象无一人越级访，有效缓解了全市大信访压力，越级访乱象得到了遏止；二是自办案件增加，上级转交件下降。2019年共受理信访举报995件，同比基本持平。其中本级自收573件，占57.59%，同比增长57.85%；上级转交办422件，占42.41%，同比下降33.02%。主要原因是随着全面从严治党不断向纵深推进，信访干部履职尽责意识不断增强，办信办访能力增强，加之信访渠道的通畅及日益拓宽，干部主动接访、带案下访、重点约访的机制发挥了积极作用，群众在本级信访诉求能够得到有效解决，越级向上反映问题大幅减少。三是信访反映村级干部增加，乡科级干部减少。2019年信访反映村（社区）人员419件，同比增长16.06%，反映乡科级干部198件，同比下降30.5%。从中不难看出在全面从严治党的高压态势下，不敢腐的震慑已经形成，不能腐的笼子正在扎牢，不想腐的自觉逐步增强，但从村干部信访举报持续增长的趋势显示，全面从严治党“最后一米”的问题还不够彻底，违反群众纪律和廉洁纪律类问题仍然居高不下，破坏了党群干群关系，蚕食了群众切身利益。 闵翼飞）</h3>
        <h3>（二）信访办理存在“三个不到位”。一是思想认识不到位。近年来，基层信访压力逐步增大，部分信访干部思想上出现了“疲劳”状态，工作中更多的是等待群众“上访”或上级转交办，下访不多，约访的主动性不强；有的干部对群众诉求重视不够，解决不力，导致小问题演变成大问题；还有的干部解决问题不彻底、不及时，或对重复访、越级访等难题消极懈怠，进一步引发了群众不满，激化了矛盾。二是措施落实不到位。2019年共受理业务范围外信访举报122件，占12.26%。从中可以看出“有问题找纪委”的现象还比较普遍，究其原因是信访举报渠道宣传的不细致、不到位，导致部分群众分不清什么问题该在本村（社区）或乡镇就能得到解决，什么问题该找公检法部门，什么问题该找纪委监委，部分群众“病急乱投医”的较为普遍，同时也额外增加了纪检监察机关办信办案工作量。三是能力素质不到位。监察体制改革后，纪委监委合署办公，部分干部尤其是基层纪检干部“熟纪不熟法”，或存在“偏科”“瘸腿”现象，办信办案能力不足，质量不高。再之，有的纪委书记、纪检委员一人身兼数职，对信访工作不上心、不研究、不投入，久而久之，成为了信访工作的“门外汉”，阻碍了信访工作高质量发展。</h3>
        <h3>（三）信访反映存在“三信三不信”。一是“信上不信下”。有的群众遇到问题不信任基层党组织，习惯性认为找上级解决管用、有效；有的群众受部分重点信访人员影响，在基层反映问题后，对基层的处理方案不满意，动辄以进京赴省访相要挟，强迫基层干部“就范”。二是“信访不信法”。少数群众对全面从严治党、依法治国等政策不了解，个人反映的一些政策外的问题得不到解决时，片面认为只有去“访”了诉求才能得到落实，权益才能得到保障。三是信闹不信理。主要表现为少数群众个人利益诉求未得到解决，转而举报干部违纪违法问题；有的群众对司法机关判决结果不满意或执行不到位，继而将公、检、法执法人员包装成黑恶势力“保护伞”，举报其涉嫌违法、失职渎职等问题；还有极少数群众信访动机复杂，以个人利益为上，为了满足自身不合理、不合法的私利或目的，多年多次多地上访，成为令人头疼的“缠访”“闹访”户。如，枣阳市生资公司退休人员姜某，从2017年4月开始连续不断到多个部门举报邻居贪腐问题，经枣阳市纪委调查不属实后仍然继续缠访闹访，转而举报居住的楼下邻居装修房屋时致使其房子多处损坏，成为危房等问题。2019年3月，枣阳市委常委、市纪委书记、市监委主任金国江同志在接访时了解到此情况后，当天便组织召开由七个单位参加的专题协调会，商讨解决其信访问题，又先后4次召开联席会议并实地调研督办工作进度，最终姜某反映住房问题得到圆满解决，其本人主动息诉罢访。</h3>
        <h3>
          <b>三、对策建议</b>
        </h3>
        <h3>信访举报工作是党和群众的“连心桥”，是依靠群众开展反腐败斗争的“主渠道”，是观察分析一个地方或单位政治生态和党风廉政状况的“体检单”和“晴雨表”。省委常委、省纪委书记王立山同志在全省纪检监察信访举报工作会议上对信访举报各项工作提出了“九个到位”的要求，深刻阐明了信访举报工作在开展党风廉政建设和反腐败斗争、加强监督执纪问责工作中的特殊重要地位和作用。做好新时代纪检监察信访举报工作，要着重从以下几个方面着手。</h3>
        <h3>（一）提高思想认识，站稳群众立场。习近平总书记强调：“信访工作的首义，在于时刻把自己看成人民中的一员，把心贴近人民”。各级纪检监察干部要牢固树立以人民为中心的思想和“大信访举报工作”理念，切实站稳群众立场，增强共同做好信访举报工作的责任感；要时刻谨记“群众到纪委来反映问题，是对纪委的信任。无论反映问题属于业务范围内外，都要认真接待、耐心倾听，尽力帮助协调解决”；要严明来访接待工作纪律，坚决杜绝盛气凌人、高高在上、当官做老爷、推诿扯皮的现象，要让来访群众感到“门好进、面好见、话好说”；要常态化推行领导班子成员定期接访制度，广泛开展领导干部带件下访、定点接访和入户走访活动，探索开展“点名约访”“赶集日接访”“巾帼信访服务队”等接访方式，变群众上访为干部下访。</h3>
        <h3>（二）坚持源头治理，压实首访责任。第一，要高度重视信访队伍建设。全市各级纪检监察组织要充实配强信访干部，挑选政治素质过硬、具有丰富群众工作经验的同志担任专职接访人员，加强对信访干部能力素质的培训，打造一支“结构优、素质高、能力强”的信访干部队伍。第二，要优先处置分流初信初访。落实“分级负责、归口办理”的原则，加大对信访举报件的研判力度，对初信初访坚持优先分流交办，跟踪督办，快查快办，着力在依法及时就地解决问题上下功夫。第三，要加强办信质量审核把关。严格执行办信质量“签字背书”制度，一方面，依托办案协作区对本片区内办理的信访件质量进行纵向审核把关，另一方面，建立以市纪委信访室、案管室、审理室为单位的横向审核体系，对每一件办结的信访件进行层层审核把关，确保“事事有回音、件件有着落”。</h3>
        <h3>（三）坚持部门联动，建立协作机制。首先，要构建“大信访”格局，建立“三抓机制”，切实推动解决群众诉求。针对信访举报反映问题业务内外交织、重复访突出的问题，在组织力量认真调查的同时，切实发挥“同级监督”作用，督促党委（党组）履行主体责任，通过建立“三抓机制”，聚焦重点领域、重点群体、重点问题、重点人员，开展信访矛盾化解攻坚，确保信访矛盾纠纷吸附在当地，化解在基层。其次，要密切联系群众，探索“乡贤机制”，及时化解农村社会矛盾。针对当前农村社会矛盾点多面广，在土地流转、农村债务、拆迁征地、涉军、涉教、涉众、失独家庭、邻里纠纷、历史遗留问题等突出的客观现状，要创新工作思路，挑选出品德高尚、公道正派、群众信任的“乡贤”，担任村（社区）信访矛盾调解员，从感情、亲情、乡情入手，引导群众理性反映诉求，就地解决小问题、小矛盾、小纠纷，用百姓的法儿平百姓的事儿，真正做到“小事不出村、大事不出镇、难事不出市”。（枣阳市委常委、市纪委书记、监委主任 金国江）</h3>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      PicBannertest1: require("../../../../assets/image/bannertest1.jpg"),
      PicBannertest2: require("../../../../assets/image/bannertest2.jpg")
    };
  },
  methods: {
    GoreportInternet() {
      this.$router.push("/forum");
    },
    GoreportEvaluation() {
      this.$router.push({ name: "forumClassroom" });
    },
    GoreportOutside() {
      this.$router.push({ name: "forumOutside" });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
/*副导航兰*/
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
/*问卷调查正文*/
.text {
  background-color: white;
  padding: 44px 60px 121px 60px;
  margin: 0 auto;
}
.text h1 {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 56px;
  text-align: center;
}
.text h2 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 44px;
  text-align: center;
   padding-bottom: 14px;
  border-bottom: 1px solid #E8E8E8;
  margin-bottom: 15px;
   text-align: center;
  display: flex;
  justify-content: center;
}
.text h3 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
  text-indent: 2em;
  margin-bottom: 30px;
}
/*静态页面样式 */
.PIC-BOX {
  display: flex;
  justify-content: center;
}
.text h3 b {
  display: block;
  margin-top: 20px;
}
img{
  margin: 20px 0px;
}
.mg-16{
  margin: 0px 16px;
}
</style>